export const AUTH_ROUTES = {
    AUTH: "/auth/",
    GOOGLE_LOGIN: "/accounts/google/login",
    MICROSOFT_LOGIN: "/accounts/microsoft/login",
}
